import { DatePipe } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { index } from 'd3'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { environment } from 'src/environments/environment'
import { AdobeLaunchService } from 'src/server/adobe-launch/adobe-launch.service'

const VMSXX_FUND_ID: string = '0045'
const VG_INTEREST_ACCUMULATION_PORTFOLIO_FUND_ID: string = '4528'

@Component({
  selector: 'app-historical-price',
  templateUrl: './historical-price.component.html',
  styleUrls: ['./historical-price.component.scss'],
  host: {
    '[attr.id]': 'selected.value',
  },
})
export class HistoricalPriceComponent implements OnInit, OnDestroy {
  public datePipe: DatePipe
  @Input() priceModel: any = {}
  @Input() historicalPriceModel: any = {}
  @Input() shareSplitDate: string | null = null
  @Input() shareSplitPrice: number | null = null
  public activeTab: number
  selected = new UntypedFormControl(0)
  aemContentSub: Subscription

  public priceHistorySearchUrl = environment.priceHistorySearch

  constructor(
    private readonly centralContentService: CentralContentService,
    public adobeLaunchService: AdobeLaunchService,
  ) {}

  moneyMarketDisclaimer: AEMChunk
  moneyMarket: string
  myTabIndex: string

  ngOnInit(): void {
    this.datePipe = new DatePipe('en-US')
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
    if (this.priceModel?.profile?.isExternalFund) {
      this.priceHistorySearchUrl = environment.priceHistorySearchExternalFunds
    } else if (this.priceModel?.profile?.isInternalFund) {
      this.priceHistorySearchUrl = environment.priceHistorySearch
    }
  }

  onTabChange($event) {
    if (this.myTabIndex !== undefined) {
      this.adobeLaunchService.subPageTabEvent(
        `${this.priceModel.profile.ticker}:Historical Price:${this.historicalPriceModel[$event].label}`,
      )
    }
    this.selected.setValue($event)
    this.myTabIndex = this.selected.value
  }

  parseAEMContent(content) {
    this.moneyMarketDisclaimer = this.centralContentService.getContentByBody(
      this.excludePriceHistoryFromDisclaimer()
        ? 'fund_definitions_vmsxx'
        : 'fund_definitions_historical_price_money_market',
      content,
    )
    this.moneyMarket = this.centralContentService
      .formatLink(this.moneyMarketDisclaimer?.contentValue)
      .replace('url', environment.vfeURLPrefix)
  }

  private excludePriceHistoryFromDisclaimer(): boolean {
    //If VMSXX
    if (VMSXX_FUND_ID === this.priceModel?.profile?.fundId) {
      return true
    }

    //If Vanguard Interest Accumulation Portfolio (529 Money Market Portfolio)
    if (
      VG_INTEREST_ACCUMULATION_PORTFOLIO_FUND_ID ===
        this.priceModel?.profile?.fundId &&
      this.priceModel?.profile?.is529
    ) {
      return true
    }

    return false
  }

  changeTab($event) {
    this.activeTab = $event
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }

  protected readonly index = index
}
